import { render, staticRenderFns } from "./CategoriesAction.vue?vue&type=template&id=4ae10dea&scoped=true&"
import script from "./CategoriesAction.vue?vue&type=script&lang=js&"
export * from "./CategoriesAction.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesAction.vue?vue&type=style&index=0&id=4ae10dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae10dea",
  null
  
)

export default component.exports